module.exports = __webpack_public_path__ + "images/klarna-t2hT0DY.svg";